"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheController = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
const models_1 = require("../api/classes/models");
class CacheController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._categoriesById = new Map();
        this._products = new Map();
    }
    getTariffBookAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._tariffBook)
                return this._tariffBook;
            if (this._tariffBookTask) {
                yield this._tariffBookTask;
                return this._tariffBook;
            }
            this._tariffBookTask = this.app.gui.lockAction(this.app.api.deliveryService.getTariffsBook());
            const tariffBook = yield this._tariffBookTask;
            if (!tariffBook)
                return undefined;
            this._tariffBook = tariffBook;
            return this._tariffBook;
        });
    }
    getCategoryAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._categoriesById.has(id))
                yield this.getCategoriesAsync();
            if (!this._categoriesById.has(id))
                return undefined;
            return this._categoriesById.get(id);
        });
    }
    getCategoriesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._categories)
                return this._categories;
            if (this._categoriesTask) {
                yield this._categoriesTask;
                return this._categories;
            }
            this._categoriesTask = this.app.gui.lockAction(this.app.api.directoryService.getCategories());
            const categories = yield this._categoriesTask;
            if (!categories)
                return undefined;
            this._categories = categories;
            for (const cat of this._categories)
                this._categoriesById.set(cat.id, cat);
            return this._categories;
        });
    }
    getProductsAsync(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = new models_1.DirectoryService_QueryProducts_Request();
            query.productIds = ids;
            let products = yield this.app.api.directoryService.queryProducts(query);
            if (!products)
                return undefined;
            for (const prod of products)
                this._products.set(prod.id, prod);
            return products;
        });
    }
    getProductAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._products.has(id))
                return this._products.get(id);
            const query = new models_1.DirectoryService_QueryProducts_Request();
            query.productIds = [id];
            let products = yield this.app.api.directoryService.queryProducts(query);
            if (!products)
                return undefined;
            if (products.length == 0)
                return undefined;
            for (const prod of products)
                this._products[prod.id] = prod;
            return products[0];
        });
    }
}
exports.CacheController = CacheController;
//# sourceMappingURL=CacheController.js.map